import React from 'react';

import { useIsSmall } from '../../../Components/Context/Hooks/mediaQueries';
import Box from '../../../Components/UI/Box';
import Banners from '../Banners';

interface MainProps {
  children: React.ReactNode;
}

const Main: React.FC<MainProps> = ({ children }) => {
  const isSmall = useIsSmall();

  return (
    <Box display="flex" flex={1} flexDirection="column">
      <Banners />
      <Box
        display="flex"
        flex={1}
        overflow="auto"
        style={{ height: '100vh' }}
        flexDirection={isSmall ? 'column' : 'row'}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Main;
